import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import SignInPage from '../../pages/AuthsPage/SignInPage/SignInPage';
import SignUpPage from '../../pages/AuthsPage/SignUpPage/SignUpPage';
import BankPage from '../../pages/BanksPage/BankPage/BankPage';
import BanksPage from '../../pages/BanksPage/BanksPage';
import TaxpayerPage from '../../pages/TaxpayersPage/TaxpayerPage/TaxpayerPage';
import TaxpayersPage from '../../pages/TaxpayersPage/TaxpayersPage';
import CouncilUserPage from '../../pages/CouncilUsersPage/CouncilUserPage/CouncilUserPage';
import CouncilUsersPage from '../../pages/CouncilUsersPage/CouncilUsersPage';
import CouncilPage from '../../pages/CouncilsPage/CouncilPage/CouncilPage';
import CouncilsPage from '../../pages/CouncilsPage/CouncilsPage';
import ErrorPage from '../../pages/ErrorPage/ErrorPage';
import ForgotPasswordPage from '../../pages/ForgotPasswordPage/ForgotPasswordPage';
import NationalParameterPage from '../../pages/NationalParametersPage/NationalParameterPage/NationalParameterPage';
import NationalParametersPage from '../../pages/NationalParametersPage/NationalParametersPage';
import ReceivablesImportPage from '../../pages/ReceivablesImportPage/ReceivablesImportPage';
import ReceivablePage from '../../pages/ReceivablesPage/ReceivablePage/ReceivablePage';
import ReceivablesPage from '../../pages/ReceivablesPage/ReceivablesPage';
import SettingsPage from '../../pages/SettingsPage/SettingsPage';
import LegalNoticePage from '../../pages/Static/LegalNoticePage/LegalNoticePage';
import PrivacyPolicyPage from '../../pages/Static/PrivacyPolicyPage/PrivacyPolicyPage';
import UserPage from '../../pages/UsersPage/UserPage/UserPage';
import UsersPage from '../../pages/UsersPage/UsersPage';
import CouncilWrapper from '../CouncilWrapper/CouncilWrapper';
import DefaultRoute from '../DefaultRoute/DefaultRoute';
import ProtectedRoute from '../ProtectedRoute/ProtectedRoute';
import TaxpayerWrapper from '../TaxpayerWrapper/TaxpayerWrapper';
import CouncilCertificatePage from '../../pages/CouncilCertificatePage/CouncilCertificatePage';
import TaxpayerReceivablesPage from '../../pages/TaxpayersPage/TaxpayerPage/TaxPayerReceivablesPage/TaxpayerReceivablesPage';
import TaxpayerVersionsPage from '../../pages/TaxpayersPage/TaxpayerPage/TaxpayerVersionsPage/TaxpayerVersionsPage';
import CouncilBanksPage from '../../pages/CouncilBanksPage/CouncilBanksPage';
import CouncilBankPage from '../../pages/CouncilBanksPage/CouncilBankPage/CouncilBankPage';

const RoutesComponent: React.FC = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute authorities={['ROLE_COUNCIL_USER']} redirectPath="/signin" />}>
                <Route path="/" element={<DefaultRoute />} />
                <Route path="/settings" element={<SettingsPage />} />

                <Route path="/councils/:councilId" element={<CouncilWrapper />}>
                    <Route index element={<CouncilPage />} />
                    <Route path="receivables" element={<ReceivablesPage />} />
                    <Route path="receivables/:id" element={<ReceivablePage />} />
                    <Route path="receivables/import" element={<ReceivablesImportPage />} />
                    <Route path="banks" element={<CouncilBanksPage />} />
                    <Route path="banks/:id" element={<CouncilBankPage />} />
                    <Route path="certificates" element={<CouncilCertificatePage />} />
                    <Route element={<ProtectedRoute authorities={['ROLE_COUNCIL_USER']} redirectPath="/" />}>
                        <Route path="users" element={<CouncilUsersPage />} />
                        <Route path="users/:id" element={<CouncilUserPage />} />
                    </Route>
                </Route>

                <Route element={<ProtectedRoute authorities={['ROLE_ADMIN']} />}>
                    <Route path="/councils" element={<CouncilsPage />} />
                    <Route path="/banks" element={<BanksPage />} />
                    <Route path="/banks/:id" element={<BankPage />} />
                    <Route path="/users" element={<UsersPage />} />
                    <Route path="/users/:id" element={<UserPage />} />
                    <Route path="/national-parameters" element={<NationalParametersPage />} />
                    <Route path="/national-parameters/:id" element={<NationalParameterPage />} />
                    <Route path="/taxpayers" element={<TaxpayersPage />} />
                    <Route path="/taxpayers/:taxpayerId" element={<TaxpayerWrapper />}>
                        <Route index element={<TaxpayerPage />} />
                        <Route path="receivables" element={<TaxpayerReceivablesPage />} />
                        <Route path="receivables/:id" element={<ReceivablePage />} />
                        <Route path="history" element={<TaxpayerVersionsPage />} />
                    </Route>
                </Route>
            </Route>

            <Route path="/signin" element={<SignInPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/legal-notice" element={<LegalNoticePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="*" element={<ErrorPage />} />
        </Routes>
    );
};
export default RoutesComponent;
